module.exports = __webpack_public_path__ + "static/media/me.3d33eca8.PNG";